import { IsString } from "class-validator";
import { Expose } from "class-transformer";

export class AddCorrectionNoteResponse {
  @IsString()
  @Expose()
  documentId!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
}
